import { useQuery } from '@tanstack/react-query';
import axios from '../../../../common/api/request';
import { TempOverviewResponse } from './types';

interface TempOverviewParams {
  page?: number;
  size?: number;
  enabled?: boolean;
}

export function useTempOverviewData(params: TempOverviewParams = {}) {
  const { page = 0, size = 10, enabled = true } = params;

  return useQuery<TempOverviewResponse>({
    queryKey: ['temp-overview-data', page, size],
    queryFn: async () => {
      const response = await axios.get('/sampling-planning/temp-overview', {
        params: {
          page,
          size,
        },
      });
      return response.data;
    },
    enabled,
    staleTime: 0, // Always refetch on page visit
    refetchOnMount: true, // Always refetch when component mounts
    refetchOnWindowFocus: false, // Don't refetch on window focus
    retry: 2,
  });
} 